import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const CostListCmp_AllCosts_QueryDocument = graphql(`
  query CostListCmp_AllCosts_Query {
    findAllCosts {
      _id
      code
      label
      statusId
    }
  }
`);

export type CostListCmp_Cost = ResultOf<
  typeof CostListCmp_AllCosts_QueryDocument
>['findAllCosts'][number];

export const useFindAllCostsQuery = (enabled = true) =>
  useGraphQLQuery(CostListCmp_AllCosts_QueryDocument, undefined, {
    enabled,
  });
